<div class="approve-dialog">
  <h2 mat-dialog-title>Onay</h2>
  
  <mat-dialog-content>
    <p>Bu talebi onaylamak istediğinizden emin misiniz?</p>
    <div class="info-section">
      <p><strong>Açıklama:</strong> {{data.explanation || 'Açıklama yok'}}</p>
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button (click)="closeModal()">İptal</button>
    <button mat-raised-button color="primary" (click)="approveRequest()">
      <mat-icon>check_circle</mat-icon>
      Onayla
    </button>
  </mat-dialog-actions>
</div>
